// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"call-off"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M5.2983 13.7017C5.20928 13.5713 5.12184 13.4398 5.03601 13.3071C3.11515 10.3382 2 6.79932 2 3H8.77778L9.97148 8.37167L7.94713 10.396L8.12978 10.706M7.56494 16.4349C8.51345 17.3834 9.56179 18.2321 10.6928 18.9638C13.6618 20.8847 17.2006 21.9998 21 21.9998V15.2221L15.6283 14.0284L13.604 16.0527C12.4249 15.3832 11.3454 14.5585 10.3934 13.6064","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M21 3L3 21","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-call-off')
export default class CallOffIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'call-off',
    }
  }
}
